/**
 * Generates accessibility props for tabs
 * @param index - Tab index
 * @returns Object with id and aria-controls attributes
 */
export function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  }
}